import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { UserHttpService } from "../../utils/common-services";
import { UserType } from "../../utils/enums";

@Injectable({
  providedIn: "root",
})
export class LoginGuardService implements CanActivate {
  constructor(private usrService: UserHttpService, private router: Router) {}

  canActivate(): boolean {
    if (
      (localStorage.getItem("intrasense-user:session") &&
        localStorage.getItem("intrasense-user:token")) ||
      (sessionStorage.getItem("intrasense-user:session") &&
        sessionStorage.getItem("intrasense-user:token"))
    ) {
      let userDetail = this.usrService.getUserInfo;
      if (userDetail.user_id) {
        this.router.navigate([userDetail.user_type == UserType.VENDOR ? '/user/chat' : '/user/tasks']);
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  }
}
